

























import {
    Answer,
    ChoiceQuestion,
    Component, ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition,
    InjectComponent, Mixins,
    Prop,
    VueComponent,
} from "@zoovu/runner-browser-api";

import QuestionBaseMixin from "./question-base.vue";
import SimpleBar from "simplebar-vue";
import {AnswersConfiguration} from "../configuration";

@Component({components: {SimpleBar}})
export default class DropDownQuestionView extends Mixins(QuestionBaseMixin) {

    @Prop()
    question: ChoiceQuestion;

    @ComponentConfig(AnswersConfiguration)
    componentConfiguration: AnswersConfiguration;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("QuestionHeadView")
    questionHeadView: VueComponent;

    dropdownOpened: boolean = false;

    get selectedAnswer(): Answer {
        return this.question.answers.find((answer) => answer.selected);
    }

    select(answerIndex: number) {
        if (!this.question.readOnly && !this.question.answers[answerIndex].disabled) {
            this.question.answers[answerIndex].select();
            this.dropdownOpened = false;
        }
    }

    showAnswer(answer: Answer): boolean {
        const showDisabled = this.componentConfiguration ? this.componentConfiguration.showDisabled : true;
        return answer && (!answer.disabled || showDisabled);
    }

    toggleDropdown() {
        if (!this.question.readOnly) {
            this.dropdownOpened = !this.dropdownOpened;
        } else {
            this.dropdownOpened = false;
        }
    }
}
